var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"estilo-texto",class:[
      _vm.bold ? 'bold-text' : '',
      _vm.error ? 'error' : '',
      _vm.success ? 'success' : '',
    ],domProps:{"textContent":_vm._s(_vm.texto)}}),_c('div',{staticClass:"estilo-linea",class:[_vm.error ? 'error-linea' : '', _vm.success ? 'success-linea' : '']})])
}
var staticRenderFns = []

export { render, staticRenderFns }